/* KHAVIYAR bundle countdown + upgrade popup (13 Sep 2026; fixed deadline 14 Sep;
   image badges 15 Sep; per-handle deadlines + The Caviar Table 16 Sep 2026; startsAt gate 20 Sep 2026;
   24 Oct 2026: after the upgrade popup (or straight after an add with nothing to offer) the cart drawer
   (assets/kh-cart-drawer.js, window.KHCart) opens instead of the /cart page.
   24 Oct 2026: Early Black Friday nightly Tables. A schedule entry with `tonight` carries the featured
   variant and its tonight-only price: the bar says "ends tonight", the PDP price shows tonight's price
   while that Table is selected, and the featured Table is preselected when the URL names no variant.
   v24, 24 Oct 2026 evening: CFG.large = Early Black Friday on 250g and up every night (the Host on this page,
   the 250g and 500g on the Royal Oscietra page), with an Early Black Friday pill.
   v27, 27 Oct 2026: our biggest Black Friday sale ever. Every Table has a tonight price (entry.prices) that rises
   at 2am AEDT (entry.next), so the bar is now a panel: the countdown to tonight's 2am price rise, every Table
   with tonight's price, the saving on buying it all separately and tomorrow's price, the free spoon + tin
   opener, and the final end date (CFG.saleEnds). Rows select the Table. The PDP pill shows the saving.)

   1. Countdown bar  - on every bundle page (CFG.isCountdownPage), counting to the
                       ONE fixed deadline in CFG.deadline. Sydney wall-clock parts
                       are converted with Intl, so it stays right across the
                       October DST change. At zero the bar removes itself. It
                       does NOT touch prices: extend the deadline in the snippet
                       or reprice by hand when the offer really ends.
   2. Upgrade popup  - Duo page only (CFG.isBundlePage): intercepts add-to-cart /
                       buy-now for the Duo and offers the 50g and 100g tiers.
   3. Image headline - (15 Sep 2026) a badge on the product image, styled like the
                       theme's "Sale" pill, carrying the end date and a live clock.
                       On the bundle product pages it sits top-left of the first
                       media (grid item AND slideshow slide, one per breakpoint). On
                       any page that lists the bundles (collection, home, search) it
                       takes over the card's own "Sale" badge, so it inherits the
                       theme's badge position and colours. Handles come from
                       CFG.countdownHandles; the clock shares the deadline above.

   Isolation from kh-upsell.js: that script matches the clicked variant against
   its own CFG.products list. The bundle's variants are not in that list, so it
   never fires here. This file additionally stops propagation once it takes a
   bundle click, so the two can never both open.                              */
(function () {
  'use strict';
  var CFG = window.KH_FLASH;
  if (!CFG) return;
  var VARIANTS = CFG.variants || [];

  var IDS = VARIANTS.map(function (v) { return String(v.id); });
  var byId = {};
  VARIANTS.forEach(function (v) { byId[String(v.id)] = v; });

  function money(n) {
    return '$' + Number(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------ countdown */
  // The deadline is Sydney wall-clock parts. Convert to an instant by guessing
  // UTC, measuring Sydney's real offset at that instant with Intl, and correcting
  // (twice, in case the guess sits on a DST edge). Falls back to the ISO string.
  function deadlineMs(d) {
    d = d || CFG.deadline || {};
    if (d.year) {
      try {
        var f = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Sydney', hourCycle: 'h23',
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric', second: 'numeric'
        });
        var wall = function (ms) {
          var p = {};
          f.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
          return Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
        };
        var guess = Date.UTC(d.year, d.month - 1, d.day, d.hour, d.minute, d.second);
        var off = wall(guess) - guess;
        var r = guess - off;
        var off2 = wall(r) - r;
        return off2 === off ? r : guess - off2;
      } catch (e) {}
    }
    var t = Date.parse(d.iso || '');
    return isNaN(t) ? 0 : t;
  }
  var END_MS = deadlineMs(CFG.deadline || {});

  function secondsLeft(end) {
    var left = Math.floor(((end || END_MS) - Date.now()) / 1000);
    return left < 0 ? 0 : left;
  }
  // Optional start gate (20 Sep 2026): a deadline may carry startsAt (ISO with offset).
  // Before that instant the offer does not exist yet: no bar, no badges, no popup.
  function notStarted(d) {
    d = d || CFG.deadline || {};
    var t = Date.parse(d.startsAt || '');
    return !isNaN(t) && Date.now() < t;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  // 30 Oct 2026 (Amin): the Pair, the Host and the Grand come with a free Caspian Chiller Bag ($49.95) while the sale runs,
  // and its value counts in every saving shown. The Duo has none, so it pushes people up to the Pair.
  function giftOf(v) {
    var g = CFG.giftInfo; if (!v || !g || !(v.gift > 0)) return 0;
    return Date.now() < Date.parse(g.ends) ? v.gift : 0;
  }
  // 31 Oct 2026: a saving is what the same items cost bought separately tonight (v.value, Chiller Bag included where it
  // comes free) minus the Table price. Never a "normal price" basis: the Tables' list prices were never charged.
  function saveOf(v) { return Math.max(0, (v.value || v.price) - v.price); }
  function pairOf() { for (var i = 0; i < VARIANTS.length; i++) if (VARIANTS[i].rank === 1) return VARIANTS[i]; return null; }
  // v28 (2 Nov 2026): the next Table up from the selected one (the Taster nudges to the Duo, the Duo to the Quad).
  function nextOf(cv) { if (!cv) return null; for (var i = 0; i < VARIANTS.length; i++) if (VARIANTS[i].rank === cv.rank + 1 && VARIANTS[i].available) return VARIANTS[i]; return null; }

  var BAR_CSS = '\
.kh-fbar{border:1px solid #c9a35c;border-radius:12px;background:linear-gradient(180deg,#14141b,#0f0f14);\
 padding:14px 18px;margin:0 0 18px;text-align:center;font-family:Montserrat,Arial,sans-serif}\
.kh-fbar__eye{display:block;font-size:10px;letter-spacing:4px;color:#e7d3a1;margin:0 0 8px}\
.kh-fbar__row{display:flex;gap:10px;align-items:baseline;justify-content:center;flex-wrap:wrap}\
.kh-fbar__lab{font-size:12px;color:#a9a49a}\
.kh-fbar__clock{font-family:"Tenor Sans",Georgia,serif;font-size:30px;letter-spacing:2px;color:#f3efe6;\
 font-variant-numeric:tabular-nums}\
.kh-fbar__end{display:block;font-size:11px;color:#6d6a64;margin-top:6px}' +
'.kh-fbar__save{display:block;font-size:12px;color:#e7d3a1;margin-top:8px;letter-spacing:.5px}' +
'.kh-fbar__big{display:block;font-family:Rosarivo,Georgia,serif;font-size:23px;line-height:1.3;color:var(--pt-navy,#000e34);margin:0 0 10px}' +
'.kh-fbar__tabs{list-style:none;margin:16px 0 4px;padding:0;text-align:left}' +
'.kh-fbar__tab{display:flex;align-items:center;gap:10px;padding:12px 14px;margin:0 0 10px;border:1px solid var(--pt-line,rgba(0,14,52,.16));background:#fff;cursor:pointer;position:relative;transition:border-color .15s,box-shadow .15s}' +
'.kh-fbar__tab:hover{border-color:var(--pt-navy,#000e34)}' +
'.kh-fbar__tab.is-on{border-color:var(--pt-navy,#000e34);box-shadow:inset 0 0 0 1px var(--pt-navy,#000e34);background:#faf9f7}' +
'.kh-fbar__tab.is-out{opacity:.45;cursor:default}' +
'.kh-fbar__tn{flex:1 1 auto;min-width:0;font-size:14px;color:var(--pt-navy,#000e34);font-weight:600}' +
'.kh-fbar__tn small{display:block;font-weight:400;font-size:12px;color:rgba(0,14,52,.68);margin-top:2px}' +
'.kh-fbar__tp{flex:0 0 auto;text-align:right}' +
'.kh-fbar__now{display:block;font-family:Rosarivo,Georgia,serif;font-size:21px;line-height:1.2;color:var(--pt-navy,#000e34)}' +
'.kh-fbar__sv{display:block;font-size:12px;color:var(--pt-teal,#008079);font-weight:700;letter-spacing:.3px}' +
'.kh-fbar__tab .kh-fbar__end{margin-top:2px!important;font-size:11px}' +
'.kh-fbar__flag{position:absolute;top:-9px;left:14px;background:var(--pt-teal,#008079);color:#fff;font-size:9.5px;letter-spacing:1.6px;font-weight:700;padding:2px 8px;text-transform:uppercase}' +
'.kh-fbar__upto{display:block;margin:0 0 12px;padding:10px 12px;background:var(--pt-navy,#000e34);color:#fff;font-family:Rosarivo,Georgia,serif;font-size:22px;line-height:1.25}' +
'.kh-fbar__upto span{display:block;font-family:Montserrat,Arial,sans-serif;font-size:11px;letter-spacing:2.5px;text-transform:uppercase;color:#e7d3a1;margin-top:4px}' +
'.kh-fbar__np{color:rgba(0,14,52,.75)!important}' +
'.kh-fbar__tt{display:block;font-size:14px;line-height:1.5;color:var(--pt-navy,#000e34);margin:-2px 0 12px}' +
'.kh-fbar__tt b{font-weight:700}' +
'.kh-fbar__flag--tn{background:var(--pt-navy,#000e34)!important}' +
'.kh-fbar__gift{display:block;font-size:13px;color:var(--pt-navy,#000e34);margin:12px 0 0;line-height:1.55}' +
'.kh-fbar__gift b{color:var(--pt-teal,#008079)}' +
'.kh-fbar__terms{display:block;font-size:12px;color:#6d6a64;margin:8px 0 0;line-height:1.5}' +
'.kh-fbar__tn small.kh-fbar__bagl{color:var(--pt-teal,#008079);font-weight:700}' +
'.kh-fbar__tn small.kh-fbar__upl{color:#8a6d2f;font-weight:600}' +
'.kh-fbar__save .kh-fbar__nudge{display:block;width:100%;margin:6px 0 2px;padding:11px 12px;border:1px solid var(--pt-teal,#008079);background:#eef7f6;color:var(--pt-navy,#000e34);font:500 13px/1.5 Montserrat,Arial,sans-serif;letter-spacing:0;text-align:left;cursor:pointer}' +
'.kh-fbar__save .kh-fbar__nudge b{color:var(--pt-teal,#008079)}' +
'.kh-fbar__save .kh-fbar__nudge:hover{background:#e2f1ef}' +
'@media(max-width:480px){.kh-fbar{padding:14px 12px}.kh-fbar__big{font-size:18px}.kh-fbar__clock{font-size:26px}.kh-fbar__now{font-size:17px}}';

  // The product page carries several /cart/add forms. The first in DOM order is a
  // ZERO-SIZE hidden Shop Pay installments form, so a naive querySelector puts the
  // bar somewhere invisible. Pick the real, visible buy form instead.
  var NOT_BUY = '.installments, .shopify-payment-terms, shopify-payment-terms,' +
                ' quick-add-component, cart-drawer-component, [data-kh-quick-add]';

  function isVisible(el) {
    if (!el || !el.offsetParent) return false;
    var r = el.getBoundingClientRect();
    return r.width > 40 && r.height > 10;
  }

  function pickBuyForm() {
    var all = [].slice.call(
      document.querySelectorAll('product-form-component, form[action*="/cart/add"]'));
    var ok = all.filter(function (el) {
      return !(el.closest && el.closest(NOT_BUY)) && isVisible(el);
    });
    for (var i = 0; i < ok.length; i++) {
      if (ok[i].tagName === 'PRODUCT-FORM-COMPONENT') return ok[i];
    }
    return ok[0] || null;
  }

  function mountCountdown() {
    if (!CFG.isCountdownPage) return true;                 // nothing to mount here
    if (document.querySelector('.kh-fbar')) return true;   // already mounted
    if (secondsLeft() <= 0 || notStarted()) return true;   // offer is over or not yet open: no bar

    var target = pickBuyForm();
    if (!target) return false;

    // 24 Oct 2026: sit above the size selector, so only the price is between the selector and the button.
    // Falls back to above the buy-buttons block when the page has no variant picker.
    var vpick = document.querySelector('.product-details variant-picker');
    var anchor = vpick || (target.closest && target.closest('.buy-buttons-block')) || target;
    if (!anchor.parentElement) return false;

    var st = document.createElement('style');
    st.textContent = BAR_CSS;
    document.head.appendChild(st);

    var bar = document.createElement('div');
    bar.className = 'kh-fbar';
    bar.setAttribute('role', 'status');
    var dl = CFG.deadline || {};
    var when = esc(dl.label || '') + (dl.timeLabel ? ' at ' + esc(dl.timeLabel) : '');
    var eye = dl.tonight ? esc(dl.eyebrow || '') + ' &middot; ENDS TONIGHT, ' + esc(dl.label || '').toUpperCase()
                         : esc(dl.eyebrow || 'FLASH OFFER') + ' &middot; ENDS ' + esc(dl.label || '').toUpperCase();
    if (dl.prices) {
      // v27 panel: the sale, the 2am price rise, every Table, the free gifts, the end date.
      var se = CFG.saleEnds || {};
      eye = esc(dl.eyebrow || 'EARLY BLACK FRIDAY') + ' &middot; ' + (dl.last ? 'LAST NIGHT, ENDS 11:59PM' : 'TONIGHT\u2019S PRICES END AT MIDNIGHT');
      var upTo = 0;
      VARIANTS.forEach(function (v) { if (v.tonight && v.available && v.everyday) upTo = Math.max(upTo, saveOf(v)); });
      var pr = pairOf();
      var tabs = VARIANTS.map(function (v) {
        if (!v.tonight) return '';
        var parts = String(v.title || '').split(' \u00b7 ');
        // v28 (2 Nov 2026): every Table has the mother of pearl spoon; the Quad and the Party add the Chiller Bag.
        var sub = (parts[1] || '') + (giftOf(v) ? ' + spoon + Chiller Bag' : ' + mother of pearl spoon');
        var extra = giftOf(v) ? '<small class="kh-fbar__bagl">Caspian Chiller Bag ($49.95) included</small>' : '';
        // 31 Oct 2026: what the same items cost bought separately tonight, under each Table (replaces "Normal price").
        // v31 (4 Nov 2026): tomorrow's price from the ladder (entry.next), or 'last night' on the final night.
        var nxt = 'Bought separately ' + money(v.value || v.price) + (v.available ? (v.next && v.next > v.price ? ' \u00b7 Tomorrow ' + money(v.next) : (dl.last ? ' \u00b7 Last night' : '')) : '');
        return '<li class="kh-fbar__tab' + (v.available ? '' : ' is-out') + '" data-kh-tab="' + esc(v.id) + '">' +
          (String(v.id) === String(dl.featured) ? '<span class="kh-fbar__flag kh-fbar__flag--tn">Our pick</span>'
            : (v.rank === 3 ? '<span class="kh-fbar__flag">Best per gram</span>' : '')) +
          '<span class="kh-fbar__tn">' + esc(parts[0] || v.title) + '<small>' + esc(sub) + '</small>' + extra + '</span>' +
          '<span class="kh-fbar__tp"><span class="kh-fbar__now">' + (v.available ? money(v.price) : 'Sold out') + '</span>' +
          (v.available ? '<span class="kh-fbar__sv">Save ' + money(saveOf(v)) + '</span>' : '') +
          '<span class="kh-fbar__end kh-fbar__np" style="margin-top:2px">' + esc(nxt) + '</span></span></li>';
      }).join('');
      bar.innerHTML = '<span class="kh-fbar__eye">' + eye + '</span>' +
        '<span class="kh-fbar__big">Black Friday on the small tins, ends tonight</span>' +
        (upTo > 0 ? '<span class="kh-fbar__upto">Save up to ' + money(upTo) + ' vs buying separately<span>' +
          esc(dl.endShort || ('Ends ' + (se.label || ''))) + '</span></span>' : '') +
        '<span class="kh-fbar__tt">Four Tables on our 30g and 50g tins, every one with the mother of pearl spoon. Tonight\u2019s prices apply in the cart automatically, no code needed, and they rise a little at midnight.</span>' +
        '<span class="kh-fbar__row"><span class="kh-fbar__lab">Tonight\u2019s prices end in</span>' +
        '<span class="kh-fbar__clock" data-kh-flash-clock>--:--:--</span></span>' +
        '<ul class="kh-fbar__tabs">' + tabs + '</ul>' +
        '<span class="kh-fbar__save" data-kh-flash-save></span>' +
        '<span class="kh-fbar__gift"><b>The mother of pearl caviar spoon</b> comes in every Table. <b>The Caspian Chiller Bag ($49.95)</b> comes in the Quad and the Party.</span>' +
        '<span class="kh-fbar__terms">Tonight\u2019s price comes off in the cart automatically, no code needed. One code per order. Codes can’t be combined with other offers or used on items that are already discounted.</span>' +
        '<span class="kh-fbar__end">' + esc(dl.endLine || '') + ' Savings compare each Table with buying the same tins, spoon and Chiller Bag separately at today\u2019s prices.' + '</span>';
      bar.addEventListener('click', function (e) {
        var li = e.target && e.target.closest ? e.target.closest('[data-kh-tab]') : null;
        if (!li || li.classList.contains('is-out')) return;
        selectVariant(byId[li.getAttribute('data-kh-tab')]);
      });
      // The panel rows are the Table picker now, so the theme's own buttons are hidden visually (still in the DOM:
      // the rows click their inputs). Only once the panel exists, so a failed mount leaves the normal picker.
      if (vpick) {
        var hs = document.createElement('style');
        hs.textContent = 'html.kh-fbar-on .product-details variant-picker{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;margin:0!important;padding:0!important;border:0!important}';
        document.head.appendChild(hs);
        document.documentElement.classList.add('kh-fbar-on');
      }
    } else {
    bar.innerHTML = '<span class="kh-fbar__eye">' + eye + '</span>' +
      '<span class="kh-fbar__row"><span class="kh-fbar__lab">Ends in</span>' +
      '<span class="kh-fbar__clock" data-kh-flash-clock>--:--:--</span></span>' +
      '<span class="kh-fbar__save" data-kh-flash-save></span>' +
      '<span class="kh-fbar__end">' + (dl.endLine ? esc(dl.endLine) : 'Offer ends ' + when + '. While stock lasts.') + '</span>';
    }
    anchor.parentElement.insertBefore(bar, anchor);

    var out = bar.querySelector('[data-kh-flash-clock]');
    var iv = null;
    function tick() {
      var t = secondsLeft();
      if (t <= 0) {                       // deadline passed while the page was open
        if (iv) clearInterval(iv);
        bar.remove();
        return;
      }
      var d = Math.floor(t / 86400), h = Math.floor((t % 86400) / 3600),
          m = Math.floor((t % 3600) / 60), s2 = t % 60;
      out.textContent = (d > 0 ? d + (d === 1 ? ' day ' : ' days ') : '') +
        pad(h) + ':' + pad(m) + ':' + pad(s2);
      // Value / price / saving of the tier currently selected in the buy form.
      var sv = bar.querySelector('[data-kh-flash-save]');
      if (sv) {
        var bf = pickBuyForm(), fld = bf && bf.querySelector('[name="id"]');
        var cv = fld && byId[String(fld.value)];
        if (cv && cv.tonight && dl.prices) {
          // v28 (2 Nov 2026): with the Taster or the Duo selected, offer the next Table up right under the rows.
          var pp = nextOf(cv), key = String(cv.id);
          if (sv.getAttribute('data-for') !== key) {
            sv.setAttribute('data-for', key);
            sv.innerHTML = (cv.rank <= 1 && pp && pp.tonight && pp.available)
              ? '<button type="button" class="kh-fbar__nudge" data-kh-tab="' + esc(pp.id) + '"><b>Step up to ' + esc(String(pp.shortTitle || '').replace(/^the /, 'The ')) + '</b> for ' +
                money(pp.price - cv.price) + ' more: ' + esc(pp.blurb || '') + ' You save ' + money(saveOf(pp)) + ' vs buying separately.</button>'
              : '';
          }
          var tl = bar.querySelectorAll('[data-kh-tab]');
          for (var k = 0; k < tl.length; k++) tl[k].classList.toggle('is-on', tl[k].getAttribute('data-kh-tab') === String(cv.id));
        } else if (cv && cv.tonight) {
          sv.textContent = 'Tonight: ' + (dl.featuredName || cv.shortTitle) + ' ' + money(cv.price) +
            ' · Bought separately ' + money(cv.value) + ' · You save ' + money(cv.value - cv.price);
        } else if (cv && cv.ebf) {
          sv.textContent = 'Every night until ' + ((CFG.large && CFG.large.endsLabel) || '2am Mon 2 Nov') + ': ' + (cv.shortTitle || '').replace(/^the /, 'The ') +
            ' ' + money(cv.price) + ' · Bought separately ' + money(cv.value) + ' · You save ' + money(cv.value - cv.price);
        } else if (cv) {
          sv.textContent = 'Bought separately ' + money(cv.value) + ' · Table price ' + money(cv.price) +
            ' · You save ' + money(cv.value - cv.price) +
            (dl.tonight && dl.featuredName ? ' · Tonight\u2019s price is on ' + dl.featuredName + ': ' + money(dl.price) : '');
        } else { sv.textContent = ''; }
      }
      applyTonightPrice(cv);
    }
    tick();
    iv = setInterval(tick, 1000);
    return true;
  }

  // Tonight's price on the PDP (24 Oct 2026). Horizon re-renders [ref=priceContainer] on every variant
  // change, so this re-applies each tick and marks the container it has rewritten.
  var TN_CSS = '.kh-tn{display:inline-block;margin-left:10px;padding:3px 8px;border:1px solid #c9a35c;border-radius:6px;' +
    'font:600 10px/1.3 Montserrat,Arial,sans-serif;letter-spacing:2px;color:#e7d3a1;vertical-align:middle;text-transform:uppercase}';
  var tnStyled = false;
  function applyTonightPrice(cv) {
    if (!CFG.isBundlePage || !cv || !(cv.tonight || cv.ebf)) return;
    var pcs = document.querySelectorAll('product-price [ref="priceContainer"]');
    for (var i = 0; i < pcs.length; i++) {
      var pc = pcs[i];
      if (pc.closest && pc.closest(NOT_BUY)) continue;
      if (pc.getAttribute('data-kh-tn') === String(cv.id)) continue;
      var p = pc.querySelector('.price');
      if (!p) continue;
      if (!tnStyled) { tnStyled = true; var st = document.createElement('style'); st.textContent = TN_CSS; document.head.appendChild(st); }
      var cur = /AUD/.test(p.textContent) ? ' AUD' : '';
      p.textContent = money(cv.price) + cur;
      // 31 Oct 2026: no struck-through reference price; the pill names the real basis instead.
      var cmp = pc.querySelector('.compare-at-price');
      if (cmp) cmp.style.display = 'none';
      var pill = document.createElement('span'); pill.className = 'kh-tn';
      pill.textContent = cv.tonight ? 'Save ' + money(saveOf(cv)) + ' vs buying separately' : 'Black Friday price';
      p.parentNode.insertBefore(pill, p.nextSibling);
      pc.setAttribute('data-kh-tn', String(cv.id));
    }
  }

  // v24 (24 Oct 2026 evening): Early Black Friday on 250g and up. On the Royal Oscietra page the 250g and
  // 500g show their every-night price (applied at checkout by the scheduled automatic discounts) and an Early Black
  // Friday pill. 31 Oct 2026: the everyday price is no longer struck through (those tins never sold at it). Re-applied
  // as Horizon re-renders.
  function applyLargePrice() {
    var lg = CFG.large;
    if (!CFG.isLargePage || !lg || !lg.on) return;
    if (Date.now() >= Date.parse(lg.ends)) return;
    var bf = pickBuyForm(), fld = bf && bf.querySelector('[name="id"]');
    var it = fld && lg.items[String(fld.value)];
    if (!it) return;
    var pcs = document.querySelectorAll('product-price [ref="priceContainer"]');
    for (var i = 0; i < pcs.length; i++) {
      var pc = pcs[i];
      if (pc.closest && pc.closest(NOT_BUY)) continue;
      if (pc.getAttribute('data-kh-tn') === String(fld.value)) continue;
      var p = pc.querySelector('.price');
      if (!p) continue;
      if (!tnStyled) { tnStyled = true; var st = document.createElement('style'); st.textContent = TN_CSS; document.head.appendChild(st); }
      var cur = /AUD/.test(p.textContent) ? ' AUD' : '';
      p.textContent = money(it[0]) + cur;
      var cmp = pc.querySelector('.compare-at-price');
      if (cmp) cmp.style.display = 'none';
      var pill = document.createElement('span'); pill.className = 'kh-tn'; pill.textContent = 'Black Friday price';
      p.parentNode.insertBefore(pill, p.nextSibling);
      pc.setAttribute('data-kh-tn', String(fld.value));
    }
  }
  function largeWhenReady() {
    if (!CFG.isLargePage || !CFG.large || !CFG.large.on) return;
    applyLargePrice();
    setInterval(applyLargePrice, 400);
  }

  // Click the theme's own variant input for v (radio buttons or a select), so Horizon re-renders price and form.
  function selectVariant(v) {
    if (!v || !v.title) return false;
    var ins = document.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]');
    for (var i = 0; i < ins.length; i++) {
      if (ins[i].value === v.title) { ins[i].click(); return true; }
    }
    var sel = document.querySelector('variant-picker select, .variant-picker select');
    if (sel) {
      for (var j = 0; j < sel.options.length; j++) {
        if (sel.options[j].value === v.title || sel.options[j].text.trim() === v.title) {
          sel.selectedIndex = j; sel.dispatchEvent(new Event('change', { bubbles: true })); return true;
        }
      }
    }
    return false;
  }

  // Preselect tonight's Table when the URL does not name a variant (ads and the strip always do).
  function preselectTonight() {
    var dl = CFG.deadline || {};
    if (!CFG.isBundlePage || !dl.tonight || !dl.featured || /[?&]variant=/.test(location.search)) return;
    var v = byId[String(dl.featured)];
    if (!v || !v.available || !v.title) return;
    var bf = pickBuyForm(), fld = bf && bf.querySelector('[name="id"]');
    if (fld && String(fld.value) === String(dl.featured)) return;
    var ins = document.querySelectorAll('variant-picker input[type="radio"], .variant-picker input[type="radio"]');
    for (var i = 0; i < ins.length; i++) {
      if (ins[i].value === v.title) { ins[i].click(); return; }
    }
    var sel = document.querySelector('variant-picker select, .variant-picker select');
    if (sel) {
      for (var j = 0; j < sel.options.length; j++) {
        if (sel.options[j].value === v.title || sel.options[j].text.trim() === v.title) {
          sel.selectedIndex = j; sel.dispatchEvent(new Event('change', { bubbles: true })); return;
        }
      }
    }
  }

  // The buy form can render after this script runs (view transitions, hydration),
  // so keep trying briefly rather than giving up on the first miss.
  function mountWhenReady() {
    if (mountCountdown()) return;
    var tries = 0;
    var iv = setInterval(function () {
      if (mountCountdown() || ++tries > 40) clearInterval(iv);
    }, 250);
  }

  /* ---------------------------------------------------- image headline */
  var HANDLES = CFG.countdownHandles || [];
  var BADGE = CFG.badge || {};
  var clocks = [];      // every live clock element on the page
  var badgeTimer = null;

  var BADGE_CSS = '\
.kh-hl{position:absolute;top:12px;left:12px;z-index:6;pointer-events:none;box-sizing:border-box;\
 background:rgba(25,25,34,.94);color:#f3efe6;border:1px solid #c9a35c;border-radius:10px;\
 padding:8px 12px 9px;font-family:Montserrat,Arial,sans-serif;line-height:1.25;text-align:left;\
 max-width:calc(100% - 24px)}\
.kh-hl__eye{display:block;font-size:10px;letter-spacing:3px;color:#e7d3a1}\
.kh-hl__ends{display:block;font-size:12px;font-weight:600;margin-top:3px;white-space:nowrap}\
.kh-hl__clock{display:block;font-family:"Tenor Sans",Georgia,serif;font-size:19px;letter-spacing:1px;\
 font-variant-numeric:tabular-nums;margin-top:2px}\
.product-badges__badge.kh-hl--inbadge{display:flex;flex-direction:column;align-items:flex-start;gap:0;border-radius:8px;padding:5px 8px 6px;text-align:left;line-height:1.25;\
 font-family:Montserrat,Arial,sans-serif;text-transform:none;letter-spacing:0}\
.product-badges__badge.kh-hl--inbadge .kh-hl__eye{font-size:8px;letter-spacing:2px}\
.product-badges__badge.kh-hl--inbadge .kh-hl__ends{font-size:10px}\
.product-badges__badge.kh-hl--inbadge .kh-hl__clock{font-size:14px}';

  var badgeStyled = false;
  function badgeStyle() {
    if (badgeStyled) return;
    badgeStyled = true;
    var st = document.createElement('style');
    st.textContent = BADGE_CSS;
    document.head.appendChild(st);
  }

  // Each handle can carry its own deadline (CFG.deadlines); the page's own is CFG.deadline.
  function dlFor(handle) { var m = CFG.deadlines || {}; return m[handle] || CFG.deadline || {}; }
  function badgeInner(dl) {
    dl = dl || CFG.deadline || {};
    var ends = dl.badgeEnds || BADGE.ends || ('Ends ' + (dl.shortLabel || dl.label || '') + (dl.timeLabel ? ', ' + dl.timeLabel : ''));
    return '<span class="kh-hl__eye">' + esc(dl.eyebrow || BADGE.eyebrow || 'FLASH OFFER') + '</span>' +
      '<span class="kh-hl__ends">' + esc(ends) + '</span>' +
      '<span class="kh-hl__clock" data-kh-hl-clock>--:--:--</span>';
  }

  function clockText(t) {
    var d = Math.floor(t / 86400), h = Math.floor((t % 86400) / 3600),
        m = Math.floor((t % 3600) / 60), s2 = t % 60;
    return (d > 0 ? d + (d === 1 ? ' day ' : ' days ') : '') + pad(h) + ':' + pad(m) + ':' + pad(s2);
  }

  function handleOf(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? m[1] : '';
  }

  // Product page: overlay on the first media in the grid and in the slideshow.
  function mountMediaBadges() {
    if (!CFG.isCountdownPage || secondsLeft() <= 0 || notStarted()) return;
    var mg = document.querySelector('media-gallery');
    if (!mg) return;
    ['.media-gallery__grid', 'slideshow-component'].forEach(function (sel) {
      var wrap = mg.querySelector(sel);
      if (!wrap) return;
      var host = wrap.querySelector('.product-media-container') ||
                 (sel === '.media-gallery__grid' ? wrap.firstElementChild : null);
      if (!host || host.querySelector('.kh-hl')) return;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      badgeStyle();
      var b = document.createElement('div');
      b.className = 'kh-hl';
      b.setAttribute('role', 'status');
      b.innerHTML = badgeInner(CFG.deadline);
      host.appendChild(b);
      clocks.push({ el: b.querySelector('[data-kh-hl-clock]'), end: END_MS, box: b });
    });
  }

  // Product cards anywhere: take over the card's "Sale" badge for the bundles.
  function mountCardBadges() {
    if (!HANDLES.length) return;
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.hasAttribute('data-kh-hl')) continue;
      var link = card.querySelector('a[href*="/products/"]');
      var h = link ? handleOf(link.getAttribute('href')) : '';
      if (!h || HANDLES.indexOf(h) === -1) continue;
      var gal = card.querySelector('.card-gallery');
      if (!gal) continue;
      var dlc = dlFor(h), endc = deadlineMs(dlc);
      card.setAttribute('data-kh-hl', '1');
      if (secondsLeft(endc) <= 0 || notStarted(dlc)) continue;  // that handle's offer is over or not yet open
      badgeStyle();
      var badge = gal.querySelector('.product-badges__badge');
      if (!badge) {
        var holder = document.createElement('div');
        holder.className = 'product-badges product-badges--top-left';
        holder.innerHTML = '<div class="product-badges__badge product-badges__badge--rectangle color-scheme-4"></div>';
        gal.appendChild(holder);
        badge = holder.firstElementChild;
      }
      badge.classList.add('kh-hl--inbadge');
      badge.innerHTML = badgeInner(dlc);
      clocks.push({ el: badge.querySelector('[data-kh-hl-clock]'), end: endc, box: badge });
    }
  }

  function tickBadges() {
    var now = Date.now(), live = [];
    for (var i = 0; i < clocks.length; i++) {
      var c = clocks[i];
      if (!c || !c.el) continue;
      var t = Math.floor((c.end - now) / 1000);
      if (t <= 0) {                     // this badge's offer is over: take it down
        if (c.box.classList.contains('kh-hl--inbadge')) {
          c.box.classList.remove('kh-hl--inbadge'); c.box.textContent = 'Sale';
        } else { c.box.remove(); }
        continue;
      }
      c.el.textContent = clockText(t);
      live.push(c);
    }
    clocks = live;
    if (!clocks.length && badgeTimer) { clearInterval(badgeTimer); badgeTimer = null; }
  }

  function mountBadges() {
    mountMediaBadges();
    mountCardBadges();
    if (clocks.length) {
      tickBadges();
      if (!badgeTimer) badgeTimer = setInterval(tickBadges, 1000);
    }
  }

  // Cards and media can render late (sections, view transitions, quick-add
  // drawers), so mount now, retry briefly, and re-run on DOM additions.
  function badgesWhenReady() {
    mountBadges();
    var tries = 0;
    var iv = setInterval(function () { mountBadges(); if (++tries > 20) clearInterval(iv); }, 500);
    var pending = null;
    try {
      new MutationObserver(function () {
        if (pending) return;
        pending = setTimeout(function () { pending = null; mountBadges(); }, 250);
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* --------------------------------------------------------------- popup */
  var STYLE = '\
.kh-fb{border:0;padding:0;background:transparent;max-width:560px;width:calc(100vw - 32px)}\
.kh-fb::backdrop{background:rgba(6,6,8,.82)}\
.kh-fb__in{background:#14141b;border:1px solid #2e2818;border-radius:14px;padding:26px 24px 22px;\
 font-family:Montserrat,Arial,sans-serif;color:#cfcabf;text-align:center}\
.kh-fb__eye{font-size:10px;letter-spacing:4px;color:#c9a35c;margin:0 0 10px}\
.kh-fb__h{font-family:"Tenor Sans",Georgia,serif;font-size:23px;line-height:1.25;color:#f3efe6;margin:0 0 6px}\
.kh-fb__sub{font-size:13px;line-height:1.6;margin:0 0 18px;color:#a9a49a}\
.kh-fb__opt{display:flex;gap:12px;align-items:center;width:100%;text-align:left;cursor:pointer;\
 background:#0f0f14;border:1px solid #2e2818;border-radius:10px;padding:13px 14px;margin:0 0 10px}\
.kh-fb__opt:hover{border-color:#c9a35c}\
.kh-fb__opt input{accent-color:#c9a35c;width:17px;height:17px;flex:0 0 auto;margin:0}\
.kh-fb__t{font-size:13px;color:#f3efe6;font-weight:600;margin:0 0 2px}\
.kh-fb__d{font-size:12px;color:#a9a49a;margin:0}\
.kh-fb__p{margin-left:auto;text-align:right;flex:0 0 auto}\
.kh-fb__now{font-family:"Tenor Sans",Georgia,serif;font-size:17px;color:#e7d3a1;display:block}\
.kh-fb__was{font-size:11px;color:#6d6a64;text-decoration:line-through}\
.kh-fb__save{display:block;font-size:11px;color:#c9a35c;margin-top:2px}\
.kh-fb__note{font-size:11px;color:#6d6a64;margin:2px 0 16px}\
.kh-fb__go{display:block;width:100%;background:#c9a35c;color:#0a0a0c;border:0;border-radius:7px;\
 padding:14px;font:700 12px/1 Montserrat,Arial,sans-serif;letter-spacing:2px;cursor:pointer}\
.kh-fb__go:hover{background:#e7d3a1}\
.kh-fb__no{display:block;width:100%;margin-top:10px;background:none;border:0;color:#6d6a64;\
 font:400 12px Montserrat,Arial,sans-serif;cursor:pointer;text-decoration:underline}\
@media(max-width:520px){.kh-fb__opt{flex-wrap:wrap}.kh-fb__p{margin-left:0;text-align:left;width:100%}}';

  var styled = false;
  function injectStyle() {
    if (styled) return;
    styled = true;
    var s = document.createElement('style');
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function qtyFor(trigger) {
    var scope = trigger.closest ? trigger.closest('product-form-component, form, [data-product-id]') : null;
    var q = scope && scope.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  var busy = false;

  function offersFor(current) {
    // Only ever offer a BIGGER tier than the one selected.
    return VARIANTS.filter(function (v) {
      return v.rank > current.rank && v.available;
    });
  }

  function open(trigger, current, qty, proceed) {
    var ups = offersFor(current);
    if (!ups.length) return proceed();

    injectStyle();
    var dlg = document.createElement('dialog');
    dlg.className = 'kh-fb';

    var rows = ups.map(function (v, i) {
      var diff = v.price - current.price;
      return '<label class="kh-fb__opt">' +
        '<input type="radio" name="kh-fb" value="' + esc(v.id) + '"' + (i === 0 ? ' checked' : '') + '>' +
        '<span><span class="kh-fb__t">' + esc(v.upgradeTitle) + '</span>' +
        '<span class="kh-fb__d">' + esc(v.blurb) + '</span></span>' +
        '<span class="kh-fb__p"><span class="kh-fb__now">' + money(v.price) + '</span>' +
        '<span class="kh-fb__was" style="text-decoration:none">Bought separately ' + money(v.value) + '</span>' +
        '<span class="kh-fb__save">Save ' + money(saveOf(v)) + (giftOf(v) ? ' incl. the Chiller Bag' : '') + ' &middot; +' + money(diff) + '</span>' +
        '</span></label>';
    }).join('');

    dlg.innerHTML = '<div class="kh-fb__in">' +
      '<p class="kh-fb__eye">' + esc((CFG.deadline && CFG.deadline.tonight && CFG.deadline.eyebrow) || 'FLASH OFFER') + '</p>' +
      '<h2 class="kh-fb__h">Step up your Table</h2>' +
      '<p class="kh-fb__sub">You picked ' + esc(current.shortTitle) + ' at ' + money(current.price) +
      '.' + (!giftOf(current) && ups.some(function (u) { return giftOf(u) > 0; })
        ? ' Step up a Table and the Caspian Chiller Bag ($49.95) comes with it.' : ' Step up a Table and the saving grows.') + '</p>' +
      rows +
      '<p class="kh-fb__note">The mother of pearl spoon comes in every Table.' + (ups.some(function (u) { return giftOf(u) > 0; }) ? ' The Quad and the Party also include the Caspian Chiller Bag.' : '') + ' While stock lasts.</p>' +
      '<button type="button" class="kh-fb__go" data-kh-fb-go>UPGRADE AND ADD TO CART</button>' +
      '<button type="button" class="kh-fb__no" data-kh-fb-no>No thanks, add ' + esc(current.shortTitle) + '</button>' +
      '</div>';

    document.body.appendChild(dlg);
    try { dlg.showModal(); } catch (e) { document.body.removeChild(dlg); return proceed(); }

    function shut() { try { dlg.close(); } catch (e) {} dlg.remove(); }

    dlg.querySelector('[data-kh-fb-no]').addEventListener('click', function () { shut(); proceed(); });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); shut(); proceed(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) { shut(); proceed(); } });

    dlg.querySelector('[data-kh-fb-go]').addEventListener('click', function () {
      var sel = dlg.querySelector('input[name="kh-fb"]:checked');
      var pick = sel ? byId[sel.value] : null;
      shut();
      if (!pick) return proceed();
      postJSON('/cart/add.js', { items: [{ id: Number(pick.id), quantity: qty }] })
        .then(function () { if (window.KHCart) window.KHCart.open(); else window.location.href = '/cart'; })
        .catch(function () { proceed(); });
    });
  }

  var ATC = ['[data-kh-atc]', 'add-to-cart-component button', 'button[name="add"]',
             'form[action*="/cart/add"] button[type="submit"]', '[data-kh-buy]'];

  document.addEventListener('click', function (e) {
    if (busy) return;
    var t = e.target && e.target.closest ? e.target.closest(ATC.join(',')) : null;
    if (!t) return;

    // Which variant is this click about?
    var scope = t.closest('product-form-component, form[action*="/cart/add"], [data-product-id]');
    var field = scope && scope.querySelector('[name="id"]');
    var id = field && String(field.value);
    if (!id || IDS.indexOf(id) === -1) return;   // not the bundle: leave it alone entirely

    var current = byId[id];
    if (!offersFor(current).length) return;      // already on the top tier

    // Take the click before kh-upsell or the theme can act on it.
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var qty = qtyFor(t);
    busy = true;
    open(t, current, qty, function () {
      busy = false;
      postJSON('/cart/add.js', { items: [{ id: Number(id), quantity: qty }] })
        .then(function () { if (window.KHCart) window.KHCart.open(); else window.location.href = '/cart'; })
        .catch(function () {
          var f = t.closest('form[action*="/cart/add"]');
          if (f) f.submit();
        });
    });
  }, true);  // capture phase, same as kh-upsell

  function boot() { mountWhenReady(); badgesWhenReady(); largeWhenReady(); setTimeout(preselectTonight, 400); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
